jQuery(document).ready(function ($) {
  const notificationsSection = document.querySelector('section.notifications');
  if (notificationsSection === null) return;
  let notifications = notificationsSection.querySelectorAll('.notification');

  if (notifications) {
    notifications.forEach(function (notification) {
      if (localStorage.getItem(notification.id) === 'closed')
        document.getElementById(notification.id).remove();
    });
    notifications = notificationsSection.querySelectorAll('.notification');

    if (notifications.length) {
      notificationsSection.style.display = 'block';
      notifications.forEach(function (notification, idx) {
        var delay = idx * 500 + 500;
        setTimeout(function () {
          $(`#${notification.id}`).slideDown();
        }, delay);
      });
    } else {
      /*  notificationsSection.remove(); */
    }
  }
  if (notifications.length) {
    $('.notification-close button').click(function () {
      localStorage.setItem(
        `notification-${$(this).data('notification')}`,
        'closed'
      );

      $(`#notification-${$(this).data('notification')}`).slideUp(function () {
        $(this).remove();
      });
    });
  }
});
